import styled from 'styled-components'
import {LeftTopRowFlexContainer} from '../../styledComponents/FlexComponents'
import { Box, DialogActions, DialogTitle } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import React, {ReactNode} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faImage} from '@fortawesome/free-regular-svg-icons'
import MeetingComment from './model/MeetingComment'
import {Colors, FontSize, FontWeights} from '../../styledComponents/Constants'
import InfoIcon from '@mui/icons-material/Info'
import MeetingCommentDetail from './model/MeetingCommentDetail'
import MeetingCommentView from './model/MeetingCommentView'
import MeetingCommentReply from './model/MeetingCommentReply'
import DeletedComment from './model/DeletedComment'
import DeletedCommentDetail from './model/DeletedCommentDetail'
import DeletedCommentView from './model/DeletedCommentView'
import DeletedCommentReply from './model/DeletedCommentReply'
import {IconProp} from '@fortawesome/fontawesome-svg-core'
import {
    faExternalLinkAlt,
    faFileAlt,
    faFileCsv,
    faFileExcel,
    faFilePdf,
    faFilePowerpoint,
    faFileWord,
    faTrash,
    faUserCircle,
} from '@fortawesome/free-solid-svg-icons'

export type MeetingCommentTypes = MeetingComment | MeetingCommentDetail | MeetingCommentView | MeetingCommentReply |
    DeletedComment | DeletedCommentDetail | DeletedCommentView | DeletedCommentReply

export function getLinkIconComponent(linkFileExtension: string = 'NONE'): ReactNode {
    switch (linkFileExtension.toUpperCase()) {
        case 'DOCX':
            return <FontAwesomeIcon icon={faFileWord}/>
        case 'XLSX':
            return <FontAwesomeIcon icon={faFileExcel}/>
        case 'PPTX':
            return <FontAwesomeIcon icon={faFilePowerpoint}/>
        case 'PDF':
            return <FontAwesomeIcon icon={faFilePdf}/>
        case 'CSV':
            return <FontAwesomeIcon icon={faFileCsv}/>
        case 'JPG':
        case 'JPEG':
        case 'PNG':
        case 'GIF':
            return <FontAwesomeIcon icon={faImage}/>
        case 'NONE':
            return <FontAwesomeIcon icon={faExternalLinkAlt}/>
        default:
            return <FontAwesomeIcon icon={faFileAlt}/>
    }
}

export const IconBoxContainer = styled(LeftTopRowFlexContainer)`
  margin-bottom: 10px;
`
export const IconBox = styled(Box)`
  min-width: 16px;
  text-align: center;
  margin-right: 5px;
`
export const MeetingIconBack = styled.span`
  width: 35px;
  height: 35px;
  border-radius: 17.5px;
  background: rgba(215, 55, 74, 0.45);
`
export const MeetingIcon = styled.span`
  width: 35px;
  height: 35px;
  display: inline-block;
  background-position: center center;
  background-repeat: no-repeat;
  background-image: url('/resources/images/assoc/assoc_meeting.svg');
`

export const BlueInfoIcon = withStyles({
    root: {
        color: Colors.Primary,
        fontSize: '24px',
    },
})(InfoIcon)

export const MeetingAttendanceDeadlineTag = styled.div`
  width: 75px;
  flex-shrink: 0;
  font-weight: ${FontWeights.Bold};
  font-size: ${FontSize.Middle};
  text-align: center;

  background: rgb(229, 241, 247)
`

export const MiddleFontSpan = styled.span`
  font-size: ${FontSize.Middle};
`

const IconStyle = styled.div<{ iconSize?: string, iconColor?: string }>`
  display: flex;
  font-size: ${props => props.iconSize ? props.iconSize : 'inherit'};
  color: ${props => props.iconColor ? props.iconColor : '#2D9CDB'};
`

export const FontAwesomeIconWrapper = (props: { icon: IconProp, iconSize?: string, iconColor?: string }) =>
    <IconStyle iconSize={props.iconSize}>
        <FontAwesomeIcon icon={props.icon} color={props.iconColor}/>
    </IconStyle>

export const UserIcon = (props: { iconSize?: string, iconColor?: string }) =>
    <FontAwesomeIconWrapper icon={faUserCircle} iconSize={props.iconSize} iconColor={props.iconColor}/>

export const UserIconLarge = () => <UserIcon iconSize={'32px'}/>
export const UserIconMedium = () => <UserIcon iconSize={'24px'}/>
export const UserIconSmall = () => <UserIcon iconSize={'20px'}/>

export const InactiveUserIconLarge = () => <UserIcon iconSize={'32px'} iconColor={'#D9D9D9'}/>
export const InactiveUserIconMedium = () => <UserIcon iconSize={'24px'} iconColor={'#D9D9D9'}/>
export const InactiveUserIconSmall = () => <UserIcon iconSize={'20px'} iconColor={'#D9D9D9'}/>

export const TrashIcon = (props: { width?: string, iconSize?: string }) =>
    <IconWithCircleStyle iconSize={props.iconSize} width={props.width}>
        <FontAwesomeIcon icon={faTrash}/>
    </IconWithCircleStyle>

const IconWithCircleStyle = styled.div<{ width?: string, iconSize?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${props => props.width ? props.width : '32px'};
  height: ${props => props.width ? props.width : '32px'};
  font-size: ${props => props.iconSize ? props.iconSize : '18px'};
  color: #BDBDBD;

  background: #FFFFFF;
  border: 1px solid #D9D9D9;
  box-sizing: border-box;
  border-radius: 50%;
`

export const NotifyDialogTitle = styled(DialogTitle)`
  &.MuiDialogTitle-root {
    padding-bottom: 0;
  }
`

export const NotifyDialogActions = styled(DialogActions)`
  &.MuiDialogActions-root {
    justify-content: space-between;
    padding: 8px 24px 16px 24px;
  }
`

export const PreWrap = styled.pre`
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  white-space: pre-wrap;
  overflow-wrap: break-word;
`

interface EllipsisTextProps {
    lineHeightInPixel: number
    numOfLines: number
    backgroundColor?: string
}

export const NewEllipsisText = styled.div<EllipsisTextProps>`
  .text {
    display: block;
    overflow: hidden;
    line-height: ${props => props.lineHeightInPixel}px;
    max-height: ${props => props.lineHeightInPixel * props.numOfLines}px;
  }

  @supports (-webkit-line-clamp: ${props => props.numOfLines}) {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: ${props => props.numOfLines};
    -webkit-box-orient: vertical;
  }
`
